import { BlogPost } from "@/data/blogPosts";

/**
 * Determina si se debe recomendar el nivel "Soporte"
 * basándose en las características de los artículos
 */
export function shouldRecommendSupport(articles: BlogPost[]): boolean {
  // Recomendar soporte SI:
  // 1. Hay artículos con recommendedSupport: true
  const hasRecommendedSupport = articles.some(a => a.recommendedSupport === true);
  
  // 2. O si hay artículos con dificultad "Requiere paciencia"
  const hasComplexArticles = articles.some(
    a => a.diyDifficulty === "Requiere paciencia"
  );
  
  // 3. Default: true (siempre recomendar soporte para maximizar conversión)
  return hasRecommendedSupport || hasComplexArticles || true;
}

/**
 * Obtiene el nivel de dificultad general de un conjunto de artículos
 */
export function getOverallDifficulty(articles: BlogPost[]): "Muy fácil" | "Requiere paciencia" {
  const difficulties = articles
    .map(a => a.diyDifficulty)
    .filter(Boolean);
  
  if (difficulties.includes("Requiere paciencia")) {
    return "Requiere paciencia";
  }
  
  return "Muy fácil";
}
